import React from "react";
import { Col, Container, Row } from "react-bootstrap";

function TemplateTermInfo({ term, data }) {
  return (
    <Container fluid>
      <Row>
        <Col lg={10}>
          <strong style={{ fontSize: "0.9em" }}>Corte {term}</strong>
          <hr />
          <div style={{ marginTop: "30px" }}>
            {data.map((ap, key) => {
              let totalPoints = 0;
              return (
                <div key={`ap_${key}`}>
                  <div style={{ fontWeight: "bold", fontSize: "0.8em" }}>
                    - {ap.name}
                  </div>
                  {ap.concepts.map((c, key) => {
                    totalPoints += c.total_points;
                    return (
                      <div key={`c_${key}`}>
                        <div
                          style={{
                            marginLeft: "20px",
                            fontWeight: "bold",
                            fontSize: "0.8em",
                          }}
                        >
                          - {c.name} (puntos {c.total_points})
                        </div>
                        {c.groups.map((g, key) => {
                          return (
                            <div key={`g_${key}`}>
                              {g.competencies.map((co, indexG) => {
                                return (
                                  <div key={`co_ti_${term}_${indexG}`}>
                                    <div
                                      style={{
                                        marginLeft: "40px",
                                        fontSize: "0.8em",
                                      }}
                                    >
                                      - {co.name}
                                    </div>
                                    {co.activities.map((a, key) => {
                                      return (
                                        <div key={`a_${key}`}>
                                          <div
                                            style={{ marginLeft: "80px" }}
                                            className="flex-row"
                                          >
                                            <span
                                              style={{
                                                marginLeft: "15px",
                                                marginTop: "5px",
                                                fontSize: "0.8em",
                                              }}
                                            >
                                              {a.name}
                                            </span>
                                          </div>
                                        </div>
                                      );
                                    })}
                                  </div>
                                );
                              })}
                            </div>
                          );
                        })}
                      </div>
                    );
                  })}
                  <hr />
                  <div style={{ fontWeight: "bold", fontSize: "0.8em" }}>
                    Total Puntos {ap.name} {totalPoints}
                  </div>
                  <hr />
                  <hr />
                </div>
              );
            })}
          </div>
        </Col>
      </Row>
    </Container>
  );
}

export default TemplateTermInfo;
